import { Card } from '@radix-ui/themes';
import ReactDiffViewer from 'react-diff-viewer-continued';
import useMiscStore from 'stores/use-misc-store';

interface IProps {
  oldValue?: string;
  newValue?: string;
  leftTitle?: string;
  rightTitle?: string;
}

export const JsonDiff = ({
  oldValue,
  newValue,
  leftTitle,
  rightTitle,
}: IProps) => {
  const isDarkMode = useMiscStore((s) => s.isDarkMode);

  return (
    <Card>
      <ReactDiffViewer
        oldValue={oldValue}
        newValue={newValue}
        leftTitle={leftTitle}
        rightTitle={rightTitle}
        styles={{
          diffContainer: {
            backgroundColor: 'transparent',
          },
          variables: {
            dark: {
              diffViewerColor: 'var(--accent-contrast)',
              diffViewerTitleColor: 'var(--accent-contrast)',
              diffViewerTitleBackground: 'var(--gray-4)',
              codeFoldContentColor: 'var(--accent-contrast)',
              codeFoldBackground: 'var(--gray-4)',
              addedBackground: 'var(--green-a11)',
              removedBackground: 'var(--red-a11)',
              addedColor: 'var(--gray-4)',
              removedColor: 'var(--gray-4)',
            },
          },
        }}
        useDarkTheme={isDarkMode}
        disableWordDiff
        hideLineNumbers
        splitView
      />
    </Card>
  );
};
